import '../index.css'
import * as React from 'react'
import { useContext } from 'react'
import { Button, Table } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { isMobile } from 'react-device-detect'
import { PlusOutlined } from '@ant-design/icons'
import { PageProps } from '../'
import { InfoCxt } from '../../../App'
import { PaddingBox, PageSubtitle, PageTitle, TabHeader, TableBox } from '../../../components/Wrapper'

const KNOW_ALLERGIES = [
  'Constipation',
  'Skin Rash',
  'Diarrhea',
  'Dizziness',
  'Dry Mouth',
  'Headache',
  'Insomnia',
  'Body Aches',
  'Fever',
  'Others',
]

interface TakenDataType {
  id: string
  dosageType: string
  dose: string | null
  medicationName: string
  originalDosage: number
  recordDateTime: string
  reportedSideEffects: string[]
  takenDosage: number
}

const columns: ColumnsType<TakenDataType> = [
  { title: 'Date', dataIndex: 'recordDateTime' },
  { title: 'Time', dataIndex: 'recordDateTime' },
  { title: 'Medication Taken', dataIndex: 'takenDosage' },
  { title: 'Allergies', dataIndex: 'reportedSideEffects' },
  { title: 'Medication Plan', render: () => null },
  { title: 'Creator', render: () => 'Patient' },
  { title: 'Action', width: '116px', render: () => null },
]

/* -------------------------------- react fc -------------------------------- */

const Taken: React.FC<PageProps> = () => {
  const { showComingSoon } = useContext(InfoCxt)

  return (
    <>
      <TabHeader border>
        <PageTitle text='Medications' />
        <Button type='primary' ghost icon={<PlusOutlined />} onClick={showComingSoon}>
          {isMobile ? null : 'Add'}
        </Button>
      </TabHeader>
      <PaddingBox>
        <PageSubtitle text='Medication Taken' />
        <TableBox>
          <Table
            columns={columns}
            dataSource={[]}
            rowKey={(record) => `${JSON.stringify(record)}`}
            pagination={false}
          />
        </TableBox>
      </PaddingBox>
    </>
  )
}

export type { TakenDataType }
export { KNOW_ALLERGIES }
export default Taken
